export default __webpack_public_path__ + "static/media/ipad.077cb651.png";